import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'isoDateFormat'
})
export class IsoDateFormatPipe implements PipeTransform {
  transform(value: string) {
    if (!value) {
      return '';
    }
    const parsedDate = new Date(value);
    const datePipe:any = new DatePipe('en-US');

    return datePipe.transform(parsedDate, 'yyyy-MM-dd', 'UTC');
  }
}